import { Component, Host, Prop, h } from '@stencil/core';
import { getLogoSize, getTeamLogo } from '@utils/imageUtils';
import { SizeVariant } from 'src/types';

@Component({
  tag: 'sportsline-team-logo',
  styleUrl: 'sportsline-team-logo.css',
  shadow: true,
})
export class SportslineTeamLogo {
  /**
   * The unique identifier for the team. This is used to fetch the corresponding team logo.
   */
  @Prop() teamId: string;
  /**
   * The size of the team logo. Acceptable values are 'small', 'medium', 'large', or 'extra-large'.
   * This determines the dimensions of the logo.
   */
  @Prop() size?: SizeVariant;
  /**
   * The alternative text for the team logo image. This is used for accessibility and displays if the image fails to load.
   */
  @Prop() alt: string;

  /**
   * variant
   */
  @Prop() variant: 'light' | 'dark' = 'light';

  render() {
    if (!Boolean(this.teamId)) {
      return null;
    }

    return (
      <Host>
        <img
          class={{
            'sportsline-team-logo': true,
            'sportsline-team-logo--small': this.size === 'small',
            'sportsline-team-logo--medium': this.size === 'medium',
            'sportsline-team-logo--large': this.size === 'large',
            'sportsline-team-logo--extra-large': this.size === 'extra-large',
          }}
          src={getTeamLogo(this.teamId, this.variant)}
          width={getLogoSize(this.size)}
          alt={this.alt}
          loading="lazy"
        />
      </Host>
    );
  }
}
